import { isPlatformServer } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { patchState, signalStore, watchState, withComputed, withHooks, withMethods, withState } from '@ngrx/signals';

const storageKey = 'pruefung-typ';

export const PrüfungsTypStore = signalStore(
  { providedIn: 'root' },
  withState({
    _kpruvid: null as number,
  }),
  withComputed(({ _kpruvid }) => ({
    KPRUVID: () => _kpruvid() || 1,
  })),
  withMethods(store => ({
    change(_kpruvid: number) {
      patchState(store, { _kpruvid });
    },
  })),
  withHooks({
    onInit(store, platformId = inject(PLATFORM_ID)) {
      if (isPlatformServer(platformId)) {
        return;
      }

      const storedState = localStorage.getItem(storageKey);
      if (storedState) {
        patchState(store, JSON.parse(storedState));
      }

      watchState(store, state => localStorage.setItem(storageKey, JSON.stringify(state)));
    },
  })
);
